<script>

/**
 * Automodal 
 * 
 * Version 1.7
 * Soporte para args,
 * 
 * Version 1.6
 * Agregado el concepto de archetypeExpedienteitemCFG, para administración de dependencias:
 *   Expedienteitem => Expedienteitem_hijo
 * 
 * Version 1.5
 * Remoción de DIV sobrante.
 * 
 * Version 1.4
 * Agrega el concepto haldeItem, que permite manipular los elementos del archetyipo independientemeente 
 * de si son arreglos de objetos o solo objetos.
 * 
 * Version 1.3
 * Remvue el concepto de archetype como prpoiedad por causar conflictos
 * Recomendado switch por item.key en cArchetype para evitar errores de ejecución.
 * 
 * Version 1.2
 * Corrige la actualización desde cArchetype automática de automodal. 
 * (Requiere "UI Edit automodal@1.10")
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el control de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'
import md5 from 'js-md5'

import {archetype, archetypeExpedienteitemCFG, automodalHandler} from './archetype'

export default {
    name: 'ExpedienteitemAutomodal',
    props: {
        conceptId: {
            type: [String, Number],
        },
        args: {
            type: Object,
            default: () => {return {}}
        }
    },
    data: () => {
        return {
            form: {
                id: null
            },
            asides: {
                // administradores: [],
                // distribuidores: [],
            }
        }
    },
    computed: {
        formArchetypeMD5(){
			return md5(JSON.stringify(this.cArchetype))
		},
        cArchetype(){
            let updated = [];
            _.forEach(archetype(), itemsRow => {
                if(!_.isArray(itemsRow)){
                    updated.push(this.handleItem(itemsRow));
                    return
                } 
                let adding = []
                _.forEach(itemsRow, item => {
                    adding.push(this.handleItem(item))
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        archetypeExpedienteitemCFG,
        beforeStore(form){
            console.log('beforeStore', form)
            return form;
        },
        handleItem(item) {
            // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO
            if (_.isObjectLike(item)) {
                switch (item.key) {
                    // case 'clientes_id':
                    //     if ((!!this.args) && (!!this.args.clientesId)) {
                    //         item.default = _.clone(this.args.clientesId);
                    //         item.type = undefined;
                    //     }
                    //     break;
                    default:
                        break;
                }
            }
            return item;
        },
        getHandler() {
            return automodalHandler(this.conceptId)
        },
        refresh() {
            this.$emit('refresh');
        },
        checkAsides() {
            const asides = this.$refs.automodal.getAsides();
            if (!!asides) {
                _.forEach(asides, (aside, asideKey) => {
                    this.asides[asideKey] = aside;
                })
                // this.asides.administradores = asides.administradores
                // this.asides.distribuidores = asides.distribuidores
            }
        },
        onDisplay() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
        },
        onHidden() {
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL SE HA OCULTADO
        },

    },
    watch: {
        'form.id'(){
            
        }
    }
}
</script>

<template>
    <ui-edit-auto-modal v-model="form"  ref="automodal" size="md" 
        :label="form.id ? 'Edit Expedienteitem' : 'New Expedienteitem'" 
        :form-id="form.id" 
        :form-archetype="cArchetype" 
        :handler="getHandler()"  
        :allow-aside="false" 
        :allow-delete="true"
        :form-key="formArchetypeMD5"
        :beforeStore="beforeStore"
        :args="args"
        @refresh="refresh()" 
        @defined="checkAsides()" 
        @display="onDisplay" 
        @hidden="onHidden">
        <slot name="default"><i class="fa fa-cog"></i></slot>
        <b-col slot="aside" cols="7">
            <!-- LATERAL, REQUIERE :allow-aside="true" -->
            <!-- <grid-input v-model="form.ExpedienteitemCfg" :archetype="archetypeExpedienteitemCFG" /> -->
        </b-col>
        <b-col slot="bottom">
            <!-- AGREGAR AL FONDO... -->
        </b-col>
    </ui-edit-auto-modal>
</template>